import { render, staticRenderFns } from "./PageView.vue?vue&type=template&id=8749d9bc&scoped=true&"
import script from "./PageView.vue?vue&type=script&lang=ts&"
export * from "./PageView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8749d9bc",
  null
  
)

export default component.exports